import mapSliceTypeToComponent from '~/imports/article_page'

import SliceManager from '~/components/SliceManager'

import { ARTICLE } from '~/data/fetch-links'
import {
  getStaticPathsFunction,
  getStaticPropsFunction,
} from '~/data/page-data'

function Article({ slices }) {
  return (
    <SliceManager
      mapSliceTypeToComponent={mapSliceTypeToComponent}
      slicesData={slices}
    />
  )
}

export default Article

export const getStaticProps = getStaticPropsFunction({
  type: 'article',
  fetchLinks: ARTICLE,
})
export const getStaticPaths = getStaticPathsFunction({ type: 'article_page' })
